import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component';
import { Container } from 'reactstrap';
import HelmetMeta from '../../components/HelmetMeta';
import HelmetTitle from '../../components/HelmetTitle';
import HelmetStyle from '../../components/HelmetStyle';
import HelmetScript from '../../components/HelmetScript';
import HelmetHead from '../../components/HelmetHead';
import Loader from '../../components/Loader';
import UnderConstruction from '../../components/UnderConstruction';
import './TestingPage.scss';
import NoMatch from '../NoMatch';
import config from '../../config';
import PageTitle from '../../widgets/PageTitle/PageTitle';
import {
  usePage,
  useTealium,
  useAdGlare,
  useUnmountResetPage,
  useNotFound,
  useDebounceLoading,
  useDelayJsLoadiing,
  useURLChangeCallback,
} from '../../utils/hookHelper';
import { sanitizedHTML } from '../../utils/Helper';

const TestingPage = (props) => {
  const { i18n, testingData, allowCookies, enableTealium, enableAdGlare, siteConfig } = props;
  const debouncePageLoading = useDebounceLoading(testingData);
  const jsLoading = useDelayJsLoadiing(testingData);
  const notFound = useNotFound(testingData);

  usePage('testing', config.pageType.staticPage, null, true);
  useAdGlare(i18n.locale, siteConfig, testingData, enableAdGlare.status);
  useUnmountResetPage();

  const siteConfigData = siteConfig.data || {};
  const { defaultLanguage } = siteConfigData;

  const { translations = {}, locale = defaultLanguage } = i18n || {};
  // const t = translations[locale] || {};

  const { data = [] } = testingData || {};
  const content = Array.isArray(data) && data.length > 0 ? data[0] : {};
  const dataContent = content[locale] || {};
  const { under_construction = false } = content;

  // HelmetMeta
  const { topMetadata = {} } = content || {};
  const publishDate = topMetadata['TeamSite/LiveSite/PublishDate'];
  const seo = dataContent.seo || {};
  const { css_style_block = '', js_script_block = '', extra_head = '' } = content;

  const title = seo.seo_title;
  const [domTitle, setDomTitle] = useState('');
  const [isScriptReady, setIsScriptReady] = useState(false);

  useTealium(
    i18n.locale,
    siteConfig,
    testingData,
    allowCookies.status,
    enableTealium.status,
    domTitle,
  );

  useURLChangeCallback(locale, content, null, [], isScriptReady);

  const helmetTitleCallBack = (newState) => {
    setDomTitle(newState.title);
  };

  const helmetScriptCallBack = (isReady) => {
    setIsScriptReady(isReady);
  };

  const mainContent = <></>;

  const pageEle = (
    <div className="testingPage">
      {notFound ? (
        <NoMatch />
      ) : (
        <>
          {under_construction && <UnderConstruction />}
          <h1 className="access-elem">{seo.seo_title}</h1>
          {!under_construction && mainContent}
          {!under_construction && (
            <HelmetScript
              helmetScriptCallBack={helmetScriptCallBack}
              extraHead={extra_head}
              jsScript={js_script_block}
            />
          )}
        </>
      )}
    </div>
  );

  return (
    <>
      {debouncePageLoading || jsLoading ? <Loader /> : pageEle}
      {!debouncePageLoading && <HelmetHead extraHead={extra_head} />}
      {!debouncePageLoading && <HelmetStyle stylesheet={css_style_block} />}
      {!debouncePageLoading && <HelmetTitle title={title} cb={helmetTitleCallBack} />}
      {!debouncePageLoading && <HelmetMeta seo={seo} publishDate={publishDate} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  testingData: state.generalPage,
  allowCookies: state.allowCookies,
  enableTealium: state.enableTealium,
  enableAdGlare: state.enableAdGlare,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(TestingPage);

export { TestingPage as TestingPageComponent }; // <- For component Unit Test
export default connectStore;
